import { _ as _sfc_main } from "./VaSkeletonGroup.vue_vue_type_script_lang-47fcf170.mjs";
import { resolveComponent, openBlock, createBlock, withCtx, createElementVNode, mergeProps, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaSkeletonGroup_vue_vue_type_style_index_0_scoped_5fabb1f3_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VaConfig = resolveComponent("VaConfig");
  return openBlock(), createBlock(_component_VaConfig, {
    components: { VaSkeleton: _ctx.config }
  }, {
    default: withCtx(() => [
      createElementVNode("div", mergeProps({
        class: ["va-skeleton-group", _ctx.bem]
      }, _ctx.$attrs), [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 16)
    ]),
    _: 3
  }, 8, ["components"]);
}
const _VaSkeletonGroup = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-5fabb1f3"]]);
export {
  _VaSkeletonGroup as _
};

import '../../../../VaSkeletonGroup.css';
//# sourceMappingURL=VaSkeletonGroup-6dbfa9ec.mjs.map
